import React, {useMemo, useState} from 'react';
import {
    Btn,
    ConfirmationContainer,
    FlexColumnSection,
    FlexRowSection,
    GreyText,
    SeparatorHorizontal,
    SmallHeader,
    SmallText
} from "../../styles/globalStyles";
import {useDispatch, useSelector} from "react-redux";
import {projectTypeMainSlice} from "@arboxappv4/shared/src/helpers/constants";
import UserAvatar from "../../components/UserAvatar";
import dayjs from "dayjs";
import {DB_DATE_FORMAT, DB_TIME_FORMAT} from "@arboxappv4/shared/src/constants/constants";
import {t} from "i18next";
import useScreenSize from "../../helpers/hooks/useScreenSize";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {regular} from "@fortawesome/fontawesome-svg-core/import.macro";
import {updateToastMessage} from "@arboxappv4/shared/src/redux/stepperSlice";
import {DisabledCta} from "../../styles/globalStyles";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {OPTIONS_CONFIRMED} from "../../../../src/constants";
import {Spin} from "antd";
import {apiAction} from "@arboxappv4/shared/src/helpers/HTTP";

const ArrivalConfirmation = () => {
    const dispatch = useDispatch();
    const {isMobile} = useScreenSize()
    const project_type = useSelector(state => state.project?.project_type);
    const language = useSelector(state => state[projectTypeMainSlice[project_type]]?.language);
    const selectedLocation = useSelector(state => state[projectTypeMainSlice[project_type]]?.selectedLocation);
    const scheduleUser = useSelector(state => state.kiosk?.scheduleUser)
    const arrival_status = scheduleUser?.schedule_user_arrivals?.arrival_statuses
    const isConfirmed = arrival_status?.status === OPTIONS_CONFIRMED
    const confirmationText = useSelector(state => state.kiosk?.confirmationText)
    const [confirmed, setConfirmed] = useState(isConfirmed)
    const [loader, setLoader] = useState(false)
    const dateLabel = useMemo(() => dayjs(scheduleUser.schedule.date, DB_DATE_FORMAT).locale(language?.code ?? 'en').format(`dddd, ${language?.code === 'he' ? 'D MMMM' : 'MMMM D'}, YYYY`), [scheduleUser, language]);
    const timeLabel = useMemo(() => dayjs(scheduleUser.schedule.time, 'HH:mm').format(selectedLocation.time_format ?? 'HH:mm'), [scheduleUser, selectedLocation]);
    const isDatePassed = useMemo(() => dayjs(scheduleUser?.schedule?.date_time?.date, DB_DATE_FORMAT + ' ' + DB_TIME_FORMAT).isBefore(dayjs()), [scheduleUser]);

    const onConfirm = async () => {
        try {
            setLoader(true)
            await apiAction('setConfirmArrivalStatus', 'post', {schedule_user_id: scheduleUser.id});
            setLoader(false)
            setConfirmed(true)
        } catch (e) {
            console.log('e', e)
        }
    }

    return (
        <FlexColumnSection flex={'unset'} overflow={'auto'}>
            <div style={{width: isMobile ? '100%' : '590px'}}>
                <ConfirmationContainer style={{flex: 'unset'}}>
                    <FlexColumnSection gap={'10px'} width={'100%'} padding={'16px'}>
                        <SmallHeader fontSize={'18px'}>{scheduleUser?.schedule.box_categories?.name}</SmallHeader>
                        <FlexColumnSection gap={'6px'}>
                            <FlexRowSection gap={'8px'} justify={'start'}>
                                <SmallText weight={'600'}>{t('date-confirmation')}:</SmallText>
                                <SmallText>{dateLabel}</SmallText>
                            </FlexRowSection>
                            <FlexRowSection gap={'8px'} justify={'start'}>
                                <SmallText weight={'600'}>{t('time-confirmation')}:</SmallText>
                                <SmallText>{timeLabel}</SmallText>
                            </FlexRowSection>
                            {scheduleUser.schedule.coach &&
                                <FlexRowSection gap={'8px'} justify={'start'}>
                                    <UserAvatar
                                        user={{
                                            ...scheduleUser.schedule.coach,
                                            cloudinary_image: scheduleUser.schedule.coach?.image || (scheduleUser.schedule.coach?.image_public_id_cloudinary ? `https://res.cloudinary.com/arbox/image/upload/c_fit,h_500,w_500,f_auto,q_auto/${scheduleUser.schedule.coach.image_public_id_cloudinary}.jpg` : undefined),
                                            user_image: scheduleUser.schedule.coach?.image
                                        }}
                                        nameType={'full'}
                                    />
                                </FlexRowSection>
                            }
                        </FlexColumnSection>
                        {confirmationText && <SeparatorHorizontal margin={'12px 0'}/>}
                        <FlexColumnSection gap={'6px'}>
                            {confirmationText}
                        </FlexColumnSection>
                        {!confirmed &&
                            <Btn loading={loader} onClick={onConfirm} width={'100%'} className={'site-primary-btn'} disabled={scheduleUser.checked_in || isDatePassed} data-date-passed={isDatePassed} style={{display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center'}}>
                                {!loader && <FontAwesomeIcon icon={regular('calendar-check')}/>}
                                {isDatePassed ? t('appointment-date-past-disable') : (scheduleUser.checked_in ? t('checked-in-disable') : t('confirm-arrival'))}
                            </Btn>
                        }
                    </FlexColumnSection>
                    {confirmed && !loader && <DisabledCta width={'100%'} bg={Colors.confirmedBadge} br={'0 0 10px 10px'} borderTop={`1px solid ${Colors.siteScheduleBorder}`}>
                        {t('arrival-confirmed')}
                    </DisabledCta>}
                </ConfirmationContainer>
            </div>
        </FlexColumnSection>
    )
}

export default ArrivalConfirmation